module.exports = __webpack_public_path__ + "static/media/pp-bg8.f23b587f.png";